
import { onMounted, reactive, computed, ref, nextTick, watch } from 'vue'
import { useStore } from 'vuex'
import { useRoute, useRouter } from 'vue-router'
import { callApi, callPostApi, sendMessageToFlutter } from '@/api/api'
import moment from 'moment'
import defaultAvatar from '@/assets/images/defaultAvatar.png'
import feildMsgIcon from '@/assets/images/mobile/icon_loading-feild-18.png'
import avatar1 from '@/assets/images/mobile/head1.png'
import avatar2 from '@/assets/images/mobile/head2.png'
import avatar3 from '@/assets/images/mobile/head4.png'
import avatar4 from '@/assets/images/mobile/head9.png'
import avatar5 from '@/assets/images/mobile/head11.png'
import avatar6 from '@/assets/images/mobile/head12.png'
import ErrorTips from '@/components/transitions/ErrorTips.vue';
import SuccessTips from '@/components/transitions/SuccessTips.vue';
export default {
    name: "Submissions",
    components: {
        ErrorTips,
        SuccessTips
    },
    setup() {
        type TipsInstance = {
            showTips: (data: { show: boolean; title: string }) => void;
        };
        const store = useStore()
        const local = computed(() => store.state.translation.locale)
        const router = useRouter()
        const route = useRoute()
        const input1 = ref<HTMLElement | null>(null)
        const perPage = ref(20)
        const page = ref(1)
        const data = reactive({
            encryptedToken: decodeURIComponent(route.query.id as any ?? null).replace(/\s/g, '+').replace(/%2B/g, '+'),
            avatarsArr: [avatar1,avatar2,avatar3,avatar4,avatar5,avatar6]
        })
        const successRef = ref<TipsInstance | null>(null);
        const errorRef = ref<TipsInstance | null>(null);
        const collapseButton = ref<HTMLElement | null>(null)
        const description = ref<string>('')
        const state = reactive({
            loadingFeatures: false,
            focusTextArea: true,
            submitting: true,
            openedContent: false,
            loadingMore: false
        })
        const submissions = computed(() => {
            if (store.state.customFeatures.submissions.length === 0 && state.loadingFeatures) {
                return Array.from({ length: 5 }, () => ({ username: local.value.loadingUserSubmission, image: defaultAvatar, description:local.value.loadingTextSubmission }))
            } else {
                return store.state.customFeatures.submissions
            }
        })

        const totalRecords = computed(() => {
            if(!store.state.customFeatures.totalRecords) {
                return 0
            } else {
                return store.state.customFeatures.totalRecords
            }
        })

        const isMore = computed(() => {
            if(store.state.customFeatures.submissions.length === 0 || store.state.customFeatures.submissions.length === store.state.customFeatures.totalRecords) {
                return false
            }
            return true
        })

        watch(description, (newVal, oldVal) => {
                if(newVal) {
                    closeComponent('submitting')
                } else {
                    openComponent('submitting')
                }
        });


        onMounted(async () => {
            input1.value?.focus()
            await store.dispatch(`translation/getLangs`, { userLang: route.query.lang ?? 'cn' })
            state.loadingFeatures = true
            refreshRecords(1)
        });

        async function submitSubmission() {
            openComponent('submitting')
             let body = {
                description: description.value,
                lang: (route.query.lang??'cn'+'')
             }
             description.value = ''
            let res = await callPostApi('/external-links/save', 'POST', JSON.stringify(body), data.encryptedToken)
                .finally(() => {
                    console.log('End submitting.')
                })
                if(res.isSuccess) {
                page.value = 1;
                showSuccessTips(local.value.submittedSuccess)
                refreshRecords(1)
            } else {
                showErrorTips(res.message)
            }
            return 0
        }

        function toggleComponent(name: string) {
            if (name in state) {
                state[name] = !state[name]
            }
        }

        function closeTab_() {
            sendMessageToFlutter('clickBack')
        }

        const closeComponent = (name: string) => {
            if (name in state) {
                state[name] = false
            }
        }

        const openComponent = (name: string) => {
            if (name in state) {
                state[name] = true
            }
        }


        const convertDate = (date) => {
            return moment(date).format("YYYY-MM-DD HH:mm")
        }


        const onIconMsgFaild = (e: Event) => {
            const target = e.target as HTMLImageElement;
            target.src = feildMsgIcon;
        }

        const jumpUrl = (url:string) => {
            window.open(url,'_blank')
        }

        const autoResize = (val) => {
            nextTick(() => {
                const element = val;
                if (element && element.scrollHeight) {
                    element.style.height = "30px"; // Reset to min height
                    element.style.height = element.scrollHeight + "px";
                }
            })
        }

        const showErrorTips = (msg) => {
            if (msg && errorRef.value) {
                errorRef.value.showTips({
                    show: true,
                    title: msg
                })
                return false
            }
        }

        const showSuccessTips = (msg) => {
            if (msg && successRef.value) {
                successRef.value.showTips({
                    show: true,
                    title: msg
                })
                return false
            }
        }

        const refreshRecords = async (page_number:number) => {
                const res = await callApi(`/external-links/suggestions?page=${page_number}&perPage=${perPage.value}`, 'GET', data.encryptedToken as any, route.query.lang + '' || 'cn')
                .finally(() => {state.loadingFeatures = false;closeComponent('loadingMore')})
                if (res.isSuccess) {
                    // setFeaturesArr ---------------------------------------------------------
                    let res1 = res.data || []
                    if(res1.length) {
                        res1 = res1.map(element => {
                            return {...element,image:data.avatarsArr[randInt0to5()],username:getDefaultUserName()}
                        });
                    }
                    if(!res1.length) res1 = []
                    if(page_number===1) {
                        await store.dispatch('customFeatures/setSubmissions', res1)
                    } else {
                        await store.dispatch('customFeatures/pushMoreRecords',res1)
                    }
                    await store.dispatch('customFeatures/setTotalRecords', res.totalRecords)
                    // --------------------------------------------------------------------------------------------
                } else {
                    showErrorTips(local.value.error_share_1)
                    await store.dispatch('customFeatures/setSubmissions', [])
                }
        }

        const showMoreRecords = () => {
            if(store.state.customFeatures.submissions.length === store.state.customFeatures.totalRecords) return 0
            openComponent('loadingMore')
            page.value++;
            refreshRecords(page.value)
        }

        const toggleTextBtn = () => {
            if(collapseButton.value && collapseButton.value.classList.contains('collapsed')) {
                closeComponent('openedContent')
            } else if(collapseButton.value && !collapseButton.value.classList.contains('collapsed')) {
                openComponent('openedContent')
            } else {
                openComponent('openedContent')
            }
        }

        const getDefaultUserName = () => {
            return "user-" + Math.random().toString(36).slice(2,6)
        }
        const randInt0to5 = () => Math.floor(Math.random() * 6);
        // -------------------------------------------------------------------------------------------
        return {
            data,
            state,
            toggleComponent,
            local,
            closeComponent,
            openComponent,
            convertDate,
            onIconMsgFaild,
            submissions,
            jumpUrl,
            closeTab_,
            submitSubmission,
            input1,
            autoResize,
            showErrorTips,
            showSuccessTips,
            successRef,
            errorRef,
            description,
            collapseButton,
            toggleTextBtn,
            getDefaultUserName,
            randInt0to5,
            perPage,
            page,
            totalRecords,
            showMoreRecords,
            isMore,
            refreshRecords
        }
    }
}

